<div *ngIf="enrollment" class="w-100">

    <app-spinner [isLoading]="isLoadingData" [isFullScreen]="false"></app-spinner>

    <div *ngIf="!isLoadingData" class="w-100">

        <p-message
            styleClass="w-100"
            *ngIf="alertMessage.show"
            [severity]="alertMessage.severity"
            [text]="alertMessage.text">
        </p-message>

        <div *ngIf="edition">

            <div class="card bg-grey-lighter-color d-flex flex-column justify-content-start align-items-stretch w-100 my-3">

                <div class="container-fluid p-2">

                    <div class="w-100">

                        <div class="d-flex flex-column justify-content-center align-items-center h-100 p-2">

                            <span class="fs-4 fw-bolder text-primary-color">{{labels.payStateLabel}}</span>

                            <button type="button" class="btn button-accent-color w-50 my-2 py-2"
                                (click)="sendPayment()"
                                [disabled]="isProcessing">

                                <div *ngIf="!isProcessing" class="d-flex flex-row justify-content-center align-items-center w-100">
                                    <fa-icon [icon]="['fas', 'credit-card']" class="me-2"></fa-icon>
                                    <span class="fs-6">{{labels.payButtonLabel}}</span>
                                </div>

                                <div *ngIf="isProcessing" class="d-flex flex-row justify-content-center align-items-center w-100">
                                    <fa-icon [icon]="['fas', 'spinner']" [spin]="true"></fa-icon>
                                </div>

                            </button>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>



</div>
